import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from '../utils';
export const getByID = async (userID, questionID) => {
    const question = await db.qnaNode.get(questionID);
    if (!question ||
        ![NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(question.type) ||
        question.deleted) {
        throw new Error('Question not found');
    }
    return getSafeData(question);
};
